import { SettingMenu } from '@bitechsystems/btappshell'
import { Button, Group } from '@mantine/core'
import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { cla_event, FramePostMsg, bt_navback } from './clarion'

const SkellyBar = () => {
  return (
    <Group position='apart'>
      <Button
        leftIcon={<AiOutlineClose color='red' size={18} />}
        onClick={() => {
          if (FramePostMsg('close', 0, null, 'backbutton')) {
            return
          }
          //@ts-ignore
          !window.dialogparent && cla_event('closewindow')
          bt_navback()
        }}
        size='xs'
        variant='default'
      >
        Close
      </Button>
      <SettingMenu />
    </Group>
  )
}

export default SkellyBar
